<template>
	<div
		class="product-zoom-container"
		:style="{ height: height, width: width }"
		@mouseenter="handleMouseEnter"
		@mousemove="handleMouseMove"
		@mouseleave="handleMouseLeave"
	>
		<img :src="src" :alt="alt" class="product-zoom-img" :style="zoomStyle" />
	</div>
</template>

<script>
export default {
	name: "ProductZoom",
	props: {
		src: {
			type: String,
			default: "",
		},
		alt: {
			type: String,
			default: "",
		},
		height: {
			type: String,
			default: "300px",
		},
		width: {
			type: String,
			default: "100%",
		},
		scale: {
			type: Number,
			default: 2.2,
		},
	},
	data() {
		return {
			isZoomed: false,
			originX: 50,
			originY: 50,
		};
	},
	computed: {
		zoomStyle() {
			return {
				transformOrigin: `${this.originX}% ${this.originY}%`,
				transform: this.isZoomed ? `scale(${this.scale})` : "scale(1)",
				cursor: this.isZoomed ? "crosshair" : "zoom-in",
			};
		},
	},
	watch: {
		src() {
			this.handleMouseLeave();
		},
	},
	methods: {
		handleMouseEnter() {
			this.isZoomed = true;
		},
		handleMouseMove(event) {
			const rect = event.currentTarget.getBoundingClientRect();
			if (!rect.width || !rect.height) return;

			const x = ((event.clientX - rect.left) / rect.width) * 100;
			const y = ((event.clientY - rect.top) / rect.height) * 100;

			this.originX = Math.max(0, Math.min(100, x));
			this.originY = Math.max(0, Math.min(100, y));
		},
		handleMouseLeave() {
			this.isZoomed = false;
			this.originX = 50;
			this.originY = 50;
		},
	},
};
</script>

<style scoped>
.product-zoom-container {
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border-radius: 4px;
	user-select: none;
}

.product-zoom-img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	pointer-events: none;
	transition: transform 0.15s ease-out;
	will-change: transform, transform-origin;
}
</style>
